"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/format/FormatType
 */

/**
 * @enum {string}
 */
var _default = {
  ARRAY_BUFFER: 'arraybuffer',
  JSON: 'json',
  TEXT: 'text',
  XML: 'xml'
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7OztlQUdlO0VBQ2JBLFlBQVksRUFBRSxhQUREO0VBRWJDLElBQUksRUFBRSxNQUZPO0VBR2JDLElBQUksRUFBRSxNQUhPO0VBSWJDLEdBQUcsRUFBRTtBQUpRLEMiLCJuYW1lcyI6WyJBUlJBWV9CVUZGRVIiLCJKU09OIiwiVEVYVCIsIlhNTCJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZm9ybWF0L0Zvcm1hdFR5cGUuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=